var map = {
	"./plain-sticker-0.png": 90,
	"./plain-sticker-1.png": 91,
	"./plain-sticker-2.png": 92,
	"./plain-sticker-3.png": 93,
	"./plain-sticker-4.png": 94,
	"./plain-sticker-5.png": 95,
	"./plain-sticker-6.png": 96,
	"./plain-sticker-7.png": 97,
	"./plain-sticker-8.png": 98,
	"./plain-sticker-9.png": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 251;